class PressQuotesTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const _this = this;
    this.focusIndex = 0;
    this.tabButtons = this.querySelectorAll('.quotes-tab-button');
    this.tabPanels = this.querySelectorAll('.quotes--tab-content blockquote');
    this.tabButtons.forEach((button, i) => {
      button.addEventListener('click', (e) => {
        _this.tabButtons.forEach(button => {
          button.setAttribute('aria-selected', 'false');
          button.setAttribute('tabindex', '-1');
        });
        e.currentTarget.setAttribute('aria-selected', 'true');
        e.currentTarget.setAttribute('tabindex', '0');
        _this.tabPanels.forEach(panel => panel.classList.add('hidden'));
        _this.tabPanels[i].classList.remove('hidden');
      });
    });

    this.addEventListener('keyup', (e) => {
      console.log(_this.focusIndex);
      
      switch(e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          _this.focusIndex = _this.focusIndex === 0 
            ? _this.tabButtons.length - 1 
            : _this.focusIndex - 1;
          _this.tabButtons[_this.focusIndex].focus();
          break;
        case 'ArrowRight':
          e.preventDefault();
          _this.focusIndex = (_this.focusIndex + 1) % (_this.tabButtons.length)
          _this.tabButtons[_this.focusIndex].focus();
          break;
        case 'ArrowUp':
          e.preventDefault();
          _this.focusIndex = (_this.focusIndex + 1) % (_this.tabButtons.length)
          _this.tabButtons[_this.focusIndex].focus();
          break;
        case 'ArrowDown':
          e.preventDefault();
          _this.focusIndex = _this.focusIndex === 0 
            ? _this.tabButtons.length - 1 
            : _this.focusIndex - 1;
          _this.tabButtons[_this.focusIndex].focus();
          break;
      }
    });
  }
}

customElements.define('press-quotes-tabs', PressQuotesTabs);
